import { WorkQueueDetails, WorkQueueState } from '@core/services/work-queue/work-queue.model';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from '../../../features.state';
import * as usQueueActions from './us-queue.actions';

export interface AppState extends fromRoot.FeaturesState {
  usmovestate: WorkQueueState;
}

export const usMoveAdapter: EntityAdapter<WorkQueueDetails> = createEntityAdapter<WorkQueueDetails>();

export const defaultUSMove: WorkQueueState = {
  ids: [],
  entities: {},
  selectedId: null,
  loading: false,
  loaded: false,
  error: '',
};

export const initialState = usMoveAdapter.getInitialState(defaultUSMove);

export function UsQueueReducer(
  state = initialState,
  action: usQueueActions.USMoveQueueAction
): WorkQueueState {
  switch (action.type) {
    case usQueueActions.USMoveQueueActionTypes.LOAD_USMOVEQUEUE_SUCCESS: {
      return usMoveAdapter.addOne(action.payload, {
        ...state,
        selectedId: action.payload.id,
      });
    }

    case usQueueActions.USMoveQueueActionTypes.LOAD_USMOVEQUEUE_FAIL: {
      return {
        ...state,
        error: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

const getUSMoveQueueState = createFeatureSelector<WorkQueueState>('usQueue');

export const getUSMoveQueue = createSelector(
  getUSMoveQueueState,
  usMoveAdapter.getSelectors().selectAll
);

export const getUSMoveQueueLoading = createSelector(
  getUSMoveQueueState,
  (state: WorkQueueState) => state.loading
);

export const getUSMoveQueueLoaded = createSelector(
  getUSMoveQueueState,
  (state: WorkQueueState) => state.loaded
);

export const getError = createSelector(
  getUSMoveQueueState,
  (state: WorkQueueState) => state.error
);

export const getCurrentUSMoveQueueId = createSelector(
  getUSMoveQueueState,
  (state: WorkQueueState) => state.selectedId
);

export const getCurrentUSMoveQueue = createSelector(
  getUSMoveQueueState,
  getCurrentUSMoveQueueId,
  state => state.entities[state.selectedId]
);
